export default "__VITE_ASSET__CbYOONgL__"